import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { delay, map, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { CookiesHandlerService } from 'src/app/core/services/cookies-handler.service';
import { TranslateService } from 'src/app/core/translate/translate.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-session-expired',
    templateUrl: './session-expired.component.html',
    styleUrls: ['./session-expired.component.css']
})
export class SessionExpiredComponent implements OnInit, OnDestroy {
    lang: string;
    private destroy$ = new Subject<void>();

    constructor(
        private router: Router,
        private authService: AuthService,
        private cookiesHandlerService: CookiesHandlerService,
        public translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.translateService.currentLang$
            .pipe(
                delay(100),
                map(lang => {
                    this.lang = lang;
                }),
                takeUntil(this.destroy$)
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    backToLogin() {
        if (environment.production) {
            this.authService.logoutTrackApi('SESSION_EXPIRY').subscribe({
                next: () => {
                    this.cookiesHandlerService.clearCookiesOnLogout();
                    this.authService.userAuthenticated = false;
                    window.location.href = environment.prefix + '/';
                },
                error: () => {
                    this.cookiesHandlerService.clearCookiesOnLogout();
                    this.authService.userAuthenticated = false;
                    window.location.href = environment.prefix + '/';
                }
            });
        } else {
            this.authService.logout();
        }
    }

    // Helper method to check current language
    isArabic(): boolean {
        return this.lang === 'ar';
    }
}
